import {FC, useEffect, useState} from 'react';
import styled from '@emotion/styled';
// custom
import { getSubText } from '../../common/helpers/CommonUtil';
import {IEvent} from '../../common/state/events/event';
import SimpleSpinner from '../loaders/spinners/SimpleSpinner';
import { IPayment } from '../../common/state/payments/payment';

type IPaymentTableProps = {
    list: IPayment[] | undefined,    
    onEdit: (data : IPayment) => void,
    onDelete: (data : IPayment) => void
};

const ContainerStyled = styled.section`
    width: 100%;
    min-height: 300px;
    max-height: 600px;
    table {
        width: 100%
    }
`;

const PaymentTableAdmin : FC <IPaymentTableProps> = ({list, onEdit, onDelete}) => {
    // states
    const [title, setTitle] = useState<string>('');
    const [subTitle, setSubTitle] = useState<string>('Please wait...');    

    // lifecycle
    useEffect(()=>{
        if (list && list.length > 0) {
            setTitle('Payment List Detail');
            setSubTitle('Payment breakdown with their corresponding amount...');
        } else if (list && list.length === 0) {
            setTitle('No Payments');
            setSubTitle('There are currently no payment info available. Click on + to add a payment');
        }
    },[list]);
    // lifecycle methods
    function populateTable(): JSX.Element {
        return <table
        className="relative w-fit table-auto border-2 border-slate-400 rounded text-gray-700 dark:text-gray-300">
        <thead className='text-gray-700 dark:text-gray-700'>
            <tr>
                <th className="py-2 px-1 border-2 border-slate-400 rounded bg-gray-300">#</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Description</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Amount</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Currency</th>                                
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Created on</th>                                
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Actions</th>                
            </tr>
        </thead>
        <tbody>
            {list && list.map((item: IPayment, index: number)=> {     
                const createdDate = new Date(item.created_date);           
                return <tr key={index}>
                    <td className="border px-1 py-2 border-2 border-slate-400 rounded text-center">{index+1}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{getSubText(item.description, 80)}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{item.amount.toFixed(2)}
                    </td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{item.currency.toUpperCase()}</td>                    
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{createdDate.toDateString()}</td>                    
                    <td className="border p-2 border-2 border-slate-400 rounded text-center">
                        <div className="inline-flex">
                            <button
                                onClick={()=>onEdit(item)}
                                className="bg-gray-300 hover:bg-gray-400 text-sm text-gray-800 font-bold py-2 px-4 rounded-l">
                                Edit
                            </button>                            
                            <button
                                onClick={()=>onDelete(item)}
                                className="bg-gray-300 hover:bg-gray-400 text-sm text-gray-800 font-bold py-2 px-4 rounded-r">
                                Delete
                            </button>
                        </div>
                    </td>
                </tr> })}
        </tbody>
    </table>;
    }
    return <ContainerStyled
        className="mt-2 relative bg-gray-100 dark:bg-gray-900 rounded-lg 
                     flex flex-col justify-start items-start shadow-lg 
                    p-4 overflow-hidden overflow-scroll">
        <div role="status"></div>
        <h2 className="text-gray-700 dark:text-teal-400 text-2xl font-medium mb-2">{title}</h2>
        <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
            {subTitle}
        </p>
        <SimpleSpinner display={`inline-block`} loading={!list} title={'Loading payments...'}/>
        {Boolean(list && list.length > 0) && populateTable()}
    </ContainerStyled>;
};

export default PaymentTableAdmin;